import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const formatDate = (dateString) => {
    if (!dateString) return '--';
    try {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
    } catch {
        return '--';
    }
};

const formatCurrency = (amount) => {
    if (!amount && amount !== 0) return '--';
    return `₹ ${parseFloat(amount).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};


const ViewDetailsModal = ({ show, onHide, selectedCase }) => (
  <Modal show={show} onHide={onHide} centered size="lg">
    <Modal.Header closeButton>
      <Modal.Title>
        Case Details
        {selectedCase && (
            <div className="text-muted fs-6 mt-1">
                {selectedCase.customer_name} ({selectedCase.lan_number})
            </div>
        )}
      </Modal.Title>
    </Modal.Header>
    <Modal.Body>
        <div className="p-2 bg-light border rounded mb-3">
            <h5 className="mb-3 border-bottom pb-2">Primary Details</h5>
            <div className="row">
                <p className="col-md-4 mb-2"><span className="fw-bold">Client:</span> {selectedCase?.client_name || '--'}</p>
                <p className="col-md-4 mb-2"><span className="fw-bold">Branch:</span> {selectedCase?.branch_name || '--'}</p>
                <p className="col-md-4 mb-2"><span className="fw-bold">LAN:</span> {selectedCase?.lan_number || '--'}</p>
            </div>
            <div className="row">
                <p className="col-md-4 mb-2"><span className="fw-bold">Product:</span> {selectedCase?.product_name || selectedCase?.product_group || '--'}</p>
                <p className="col-md-4 mb-2"><span className="fw-bold">Claim Amount:</span> {formatCurrency(selectedCase?.claim_amount)}</p>
                <p className="col-md-4 mb-2"><span className="fw-bold">Loan Amount:</span> {formatCurrency(selectedCase?.loan_amount)}</p>
            </div>
            <div className="row">
                <p className="col-md-4 mb-2"><span className="fw-bold">ROI:</span> {selectedCase?.roi_percentage ? `${selectedCase.roi_percentage}%` : '--'}</p>
                <p className="col-md-4 mb-2"><span className="fw-bold">Borrower Type:</span> {selectedCase?.borrower_type || '--'}</p>
            </div>
        </div>

        <div className="p-2 bg-light border rounded mb-3">
            <h5 className="mb-3 border-bottom pb-2">Filing & Status</h5>
            <div className="row">
                <p className="col-md-4 mb-2"><span className="fw-bold">E-Filing No:</span> {selectedCase?.e_filing_case_number || '--'}</p>
                <p className="col-md-4 mb-2"><span className="fw-bold">Case No:</span> {selectedCase?.case_no || '--'}</p>
                <p className="col-md-4 mb-2"><span className="fw-bold">Case Status:</span> <span className="text-primary fw-bold">{selectedCase?.case_status || '--'}</span></p>
            </div>
            <div className="row">
                <p className="col-md-4 mb-2"><span className="fw-bold">Stage of Case:</span> {selectedCase?.stage_of_case || '--'}</p>
                <p className="col-md-4 mb-2"><span className="fw-bold">Next Hearing:</span> {formatDate(selectedCase?.next_hearing_date)}</p>
                <p className="col-md-4 mb-2"><span className="fw-bold">Previous Hearing:</span> {formatDate(selectedCase?.previous_hearing_date)}</p>
            </div>
        </div>

        <div className="p-2 bg-light border rounded mb-3">
            <h5 className="mb-3 border-bottom pb-2">Related Parties</h5>
            <div className="row">
                <p className="col-md-6 mb-2"><span className="fw-bold">Proprietor:</span> {selectedCase?.proprietor_name || '--'}</p>
                <p className="col-md-6 mb-2"><span className="fw-bold">Proprietor Address:</span> {selectedCase?.proprietor_address || '--'}</p>
            </div>
            <div className="row">
                <p className="col-md-6 mb-2"><span className="fw-bold">Guarantor(s):</span> {selectedCase?.guarantor_name || '--'}</p>
                <p className="col-md-6 mb-2"><span className="fw-bold">Guarantor Address:</span> {selectedCase?.guarantor_address || '--'}</p>
            </div>
            <div className="row">
                <p className="col-md-6 mb-2"><span className="fw-bold">Co-Borrower:</span> {selectedCase?.coborrower1_name || '--'}</p>
                <p className="col-md-6 mb-2"><span className="fw-bold">Co-Borrower Address:</span> {selectedCase?.coborrower1_address || '--'}</p>
            </div>
        </div>

        <div className="p-2 bg-light border rounded">
            <h5 className="mb-3 border-bottom pb-2">Important Dates</h5>
            <div className="row">
                <p className="col-md-4 mb-2"><span className="fw-bold">NPA Date:</span> {formatDate(selectedCase?.npa_date)}</p>
                <p className="col-md-4 mb-2"><span className="fw-bold">Agreement Date:</span> {formatDate(selectedCase?.agreement_date)}</p>
                <p className="col-md-4 mb-2"><span className="fw-bold">LRN Date:</span> {formatDate(selectedCase?.lrn_date)}</p>
            </div>
            <div className="row">
                <p className="col-md-4 mb-2"><span className="fw-bold">Sanction Date:</span> {formatDate(selectedCase?.sanction_date)}</p>
                <p className="col-md-4 mb-2"><span className="fw-bold">Application Date:</span> {formatDate(selectedCase?.application_date)}</p>
                <p className="col-md-4 mb-2"><span className="fw-bold">Incorporation Date:</span> {formatDate(selectedCase?.incorpration_date)}</p>
            </div>
            <div className="row">
                <p className="col-md-4 mb-2"><span className="fw-bold">Disbursal Date:</span> {formatDate(selectedCase?.disbursal_date)}</p>
                <p className="col-md-4 mb-2"><span className="fw-bold">Award Date:</span> {formatDate(selectedCase?.award_date)}</p>
                <p className="col-md-4 mb-2"><span className="fw-bold">Outstanding As On:</span> {formatDate(selectedCase?.outstanding_date_as_on)}</p>
            </div>
        </div>
    </Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={onHide}>Close</Button>
    </Modal.Footer>
  </Modal>
);

export default ViewDetailsModal;